<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Cadastro de Cooperado.</span>
                <br />
                <span class="navigation">Cadastros > Cooperado</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <form name="form" @submit.prevent="onSubmit">
            <div class="row">
              <div class="col-md-6 mb-2">
                <label for="nome">Nome:</label>
                <span class="p-fluid">
                  <InputText type="text" id="nome" v-model="cooperado.nome" />
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2 col-lg-2 mb-2">
                <label for="tipoPessoa">Tipo: </label>
                <span class="p-fluid">
                  <Dropdown
                    id="tipoPessoa"
                    v-model="selectedTipoPessoa"
                    :options="tiposPessoa"
                    optionLabel="name"
                    placeholder="Selecione um Tipo de Pessoa"
                  />
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2 col-lg-3 mb-2">
                <template v-if="selectedTipoPessoa && selectedTipoPessoa.key === 'F'">
                  <InputMask
                    id="cpfCnpj"
                    type="text"
                    placeholder="CPF"
                    autocomplete="off"
                    v-model="cooperado.numeroDocumentoJuridico"
                    mask="999.999.999-99"
                    key="F"
                    @blur="validarDocumento()"
                  />
                </template>
                <template v-else>
                  <InputMask
                    id="cpfCnpj"
                    type="text"
                    placeholder="CNPJ"
                    autocomplete="off"
                    v-model="cooperado.numeroDocumentoJuridico"
                    mask="**.***.***/****-99"
                    key="J"
                    @blur="validarDocumento()"
                    style="text-transform: uppercase;"
                  />
                </template>
              </div>
            </div>
            <hr />
            <template>
              <Button
                label="Gravar"
                title="Gravar"
                type="submit"
                class="p-button-primary mr-2 p-button-success"
                icon="pi pi-check"
                :disabled="loading"
              >
              </Button>
              <router-link to="/CooperadoConsulta">
                <Button
                  label="Voltar"
                  title="Voltar"
                  type="button"
                  class="p-button-primary mr-2"
                  icon="pi pi-arrow-left"
                  :disabled="loading"
                ></Button>
              </router-link>
            </template>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LoginService from '../services/acesso/login.service';
import CooperadoService from '../services/nfse/cooperado.service';
import Cooperado from '../models/nfse/Cooperado';
import Util from '../Utils/util';

export default {
  name: 'CooperadoCadastro',
  data() {
    return {
      currentUser: null,
      loading: false,
      cooperado: new Cooperado(),
      selectedTipoPessoa: null,
      tiposPessoa: [
        { name: 'Pessoa Física', key: 'F' },
        { name: 'Pessoa Jurídica', key: 'J' },
      ],
    };
  },
  created() {
    this.currentUser = LoginService.currentUserValue;
    this.idCooperado = this.$route.params.id;
    this.selectedTipoPessoa = this.tiposPessoa[0];

    if (this.idCooperado != null) {
      setTimeout(async () => {
        await CooperadoService.get(this.idCooperado).then(
          (response) => {
            this.cooperado = response.data;
            if (this.cooperado.numeroDocumentoJuridico && this.cooperado.numeroDocumentoJuridico.length >= 18) {
              this.selectedTipoPessoa = this.tiposPessoa[1];
            }
          },
          (error) => {
            let errorMessage = 'Houve um problema ao buscar o Cooperado!';
            if (error.response) {
              errorMessage = error.response.data;
            }
            this.$toast.add({
              severity: 'error',
              summary: errorMessage,
            });
          },
        );
      }, 250);
    }
  },
  methods: {
    validarDocumento() {
      if (this.cooperado.numeroDocumentoJuridico) {
        var validar = false;
        validar = Util.validarCPFCNPJ(this.cooperado.numeroDocumentoJuridico);

        if (!validar) {
          console.log(validar);
          this.$root.$emit('alert:error', 'CPF/CNPJ: ' + this.cooperado.numeroDocumentoJuridico + ' inválido!');
          this.cooperado.numeroDocumentoJuridico = '';
        }
      }
    },
    onSubmit() {
      this.loading = true;
      let msg = null;
      let msg2 = null;
      if (!this.cooperado.nome) {
        msg = 'É necessário preencher o campo Nome!';
      }
      if (!this.cooperado.numeroDocumentoJuridico) {
        msg2 = 'É necessário preencher o campo Documento!';
      }

      if (!msg && !msg2) {
        this.salvar();
      } else {
        if (msg) {
          this.$root.$emit('alert:warn', msg);
        }
        if (msg2) {
          this.$root.$emit('alert:warn', msg2);
        }
        this.loading = false;
      }
    },
    salvar() {
      this.cooperado.idCliente = this.currentUser.usuario.idCliente;
      this.cooperado.idContribuinte = this.currentUser.contribuinte.idContribuinte;
      CooperadoService.saveCooperado(this.cooperado).then(
        (data) => {
          console.log(data);
          this.$toast.add({
            severity: 'success',
            summary: 'Cooperado salvo com sucesso',
          });
          this.limparCampos();
          this.loading = false;
          this.$router.push('/CooperadoConsulta');
        },
        (error) => {
          let errorMessage = 'Houve um problema ao salvar o Cooperado!';
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: 'error',
            summary: errorMessage,
          });
        },
      );
    },
    limparCampos() {
      this.cooperado.nome = '';
      this.cooperado.numeroDocumentoJuridico = '';
    },
  },
};
</script>

<style scoped></style>
